import { render, staticRenderFns } from "./publisher-group-create.vue?vue&type=template&id=282b6d2a&"
import script from "./publisher-group-create.vue?vue&type=script&lang=js&"
export * from "./publisher-group-create.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports